<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-level`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 24c0-12.15-9.85-22-22-22S2 11.85 2 24s9.85 22 22 22 22-9.85 22-22zM18.49 6.86A17.989 17.989 0 0124 6c1.922 0 3.774.301 5.51.86a.914.914 0 00-.01.14v34c0 .048.003.095.01.14-1.736.559-3.588.86-5.51.86-1.922 0-3.774-.301-5.51-.86a.914.914 0 00.01-.14V7a.91.91 0 00-.01-.14zM14.5 8.707C9.397 11.885 6 17.546 6 24c0 6.454 3.397 12.115 8.5 15.292V8.708zM42 24c0 6.454-3.396 12.114-8.5 15.291V8.71C38.605 11.886 42 17.546 42 24z"/></svg>
</template>
<script>

export default {
  name: 'IconLevel',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
